<template>
    <div class="slim-profile">
        <slim-cropper :options="slimOptions">
            <input type="file" name="avatar_location[]"/>
        </slim-cropper>
    </div>
</template>

<script>
import Slim from './slim.vue'

export default {
    name: 'SlimProfile',
    components: {
        'slim-cropper': Slim
    },
    data () {
        return {
            endpoint: '/profile/image/update',
            submitObjects: [],
            slimOptions: {
                ratio: '1:1',
                initialImage: _.get(this.Ambition, 'Globals.tenant.user.avatar', null),
                service: this.slimService
            }
        }
    },
    computed: {
      submitObject() {
        let formData = [];
        this.submitObjects.forEach((data, index) => {
            for (let pair of data[0].entries()) {
                formData.push([pair[0], pair[1]]);
            }
        });
        return formData;
      }
    },
    watch: {
      submitObjects(newVal, oldVal) {
        if (this.submitObjects.length > 0) {
            this.submit();
        }
      }
    },
    methods: {
        slimService (formdata, progress, success, failure, slim) {
            slim.requestOutput((fileData, formData) => {
                this.submitObjects.push([formData]);
            });
        },
        async submit() {

        const data = this.submitObject;
        let fileNames = [];
        let formData = new FormData();

        data.map(item => {
          formData.append(item[0], item[1]);
          if (item[1].name !== undefined) {
            fileNames.push(item[1].name);
          }
        });

        const config = {
          headers: {
            Authorization: `Bearer ${_.get(this.Ambition, 'Globals.tenant.token')}`,
            "Content-Type": "multipart/form-data"
          }
        }

        try {
          let res = await axios.post(
            `${this.endpoint}`,
            formData,
            config
          );
        } catch (Err) {
          console.error(Err);
        }

      }
    }
}
</script>
<style lang="scss">
    .slim-profile {
        width: 240px;
        height: 240px;
        max-width: 100%;
        border-radius: 50%;
        overflow: hidden;
    }
</style>
